import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { useModal } from '@/context/ModalContext'
import { LEAD_FORM_ENABLED } from '@/data/contact'
import { ContactDetails } from './ContactDetails'
import { LeadForm } from './LeadForm'

export function ContactModal() {
  const { t } = useTranslation()
  const { isOpen, close } = useModal()

  const titleKey = LEAD_FORM_ENABLED ? 'modal.title' : 'contact.title'
  const subtitleKey = LEAD_FORM_ENABLED ? 'modal.subtitle' : 'contact.subtitle'

  return (
    <Dialog open={isOpen} onOpenChange={open => { if (!open) close() }}>
      <DialogContent className="p-0 overflow-hidden rounded-2xl shadow-2xl bg-white">
        <DialogTitle className="sr-only">{t(titleKey)}</DialogTitle>

        {/* Top accent bar */}
        <div className="h-1 bg-gradient-to-r from-primary via-primary-light to-primary/40" />

        <div className="px-8 pt-8 pb-9 sm:px-10">
          {/* Brand chip */}
          <div className="flex items-center gap-1.5 mb-6">
            <img src="/SAMLY_LOGO.png" alt="Samly" className="h-7 w-auto" />
            <span className="text-[11px] font-semibold tracking-[0.12em] text-primary uppercase px-1.5 py-0.5 rounded bg-primary/10">
              POS
            </span>
          </div>

          <h2 className="text-[22px] sm:text-[26px] font-bold text-foreground leading-tight tracking-tight mb-1.5">
            {t(titleKey)}
          </h2>
          <p className="text-[14px] text-foreground/50 leading-relaxed mb-7">
            {t(subtitleKey)}
          </p>

          {LEAD_FORM_ENABLED ? <LeadForm onSuccess={close} /> : <ContactDetails />}

          <p className="mt-5 text-center text-[12px] text-foreground/35">
            {t('contact.trust')}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  )
}
